import { faDownload, faEdit, faMicrophone } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { Badge, Card, Col, Row } from "react-bootstrap";
import { Note } from "../../../../types/note";
import IconButton from "../../../ui/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "react-tooltip";

interface ReferralViewState {
  n: Note;
  setEdit: any;
  setCurrent: any;
  downloadReport: any;
  setReportType: any;
}

const ReferralView = ({ n, setEdit, setCurrent, downloadReport, setReportType }: ReferralViewState) => {
  const [running, setRunning] = useState<boolean>(false);

  const onClickEdit = () => {
    setEdit(true);
    setCurrent(n);
  };

  const onClickDownload = async (e: any) => {
    e.stopPropagation();
    setRunning(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));

    setReportType("Referral");
    const download = await downloadReport(e, n);
    setRunning(false);
  };

  return (
    <Card id={"note-card-" + n?.id} className="bg-light mb-3 cursor-pointer" onClick={(e) => onClickEdit()}>
      <Card.Body>
        <>
          <Row>
            <Col>
              <h5 className="app-orange-text">Referral</h5>
            </Col>
            <Col className="text-end">
              <label className="note-type text-muted me-3">{n.fields.date}</label>
              <FontAwesomeIcon
                data-tooltip-id={"note-download-tooltip-" + n?.id}
                data-tooltip-content="Download Note"
                id={"note-download-button-" + n?.id}
                className="text-muted cursor-pointer me-3"
                icon={faDownload}
                onClick={(e) => onClickDownload(e)}
              />
              <Tooltip id={"note-download-tooltip-" + n?.id} place="top" style={{ padding: "5px 10px" }} />
              <FontAwesomeIcon
                data-tooltip-id={"note-edit-tooltip-" + n?.id}
                data-tooltip-content="Edit Note"
                id={"note-edit-button-" + n?.id}
                className="text-muted cursor-pointer"
                icon={faEdit}
                onClick={(e) => onClickEdit()}
              />
              <Tooltip id={"note-edit-tooltip-" + n?.id} place="top" style={{ padding: "5px 10px" }} />{" "}
            </Col>
          </Row>
          <Row>
            {n.fields.referred_to && <h6>Referred To {n.fields.referred_to}</h6>}
            {n.fields.referral_contact && <p>Contact Info - {n.fields.referral_contact}</p>}
          </Row>
          <Row>
            <div
              id="capture-text"
              style={{
                height: running ? "auto" : "80px",
                pointerEvents: "none",
                backgroundColor: "#e9ecef",
                color: "#6c757d",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
                overflow: "hidden",
                border: "1px solid #ccc",
                padding: "5px",
              }}
            >
              {n.fields.reason ? n.fields.reason : ""}
            </div>
          </Row>
          <Row className="mt-1">
            <Col className="col-6 text-start">
              <Badge bg="secondary" className="me-3">
                Created By {n.firstname} {n.lastname}
              </Badge>
              {n?.recordingsExist === true && <IconButton tooltipText="Recordings Exist" icon={faMicrophone} />}
            </Col>
            <Col className="col-6 text-end">
              {n.subject?.room && (
                <Badge bg="secondary" className="me-2">
                  {n.subject?.room + " " + n.subject?.bed}
                </Badge>
              )}
              <Badge bg="secondary">{n.subject?.name}</Badge>
            </Col>
          </Row>
        </>
      </Card.Body>
    </Card>
  );
};

export default ReferralView;
